import api from './api';

export function search(query, options = {}) {
  return api.get(`/api/v2/search?query=${encodeURI(query)}`, options);
}
